export const signupUrl = ({ search } = {}) =>
  search ? `/signup?${search}` : '/signup';
